import { axios_post } from '@/utils/request.js';

/**
 * 按需导出 API 函数
 * 官网提交表单，收集用户信息
 * /api/client/joinus 表示当发起的请求路径以 /api 开头时，将会触发代理配置
 */
export const gameInfos = function(data) {
    // console.log('=== gameInfosApi > gameInfos <<<');
    return axios_post('/api/bytesungame/game-infos-list', data);
};

export const gameInfosNew = function(data) {
    // console.log('=== gameInfosApi > gameInfosNew <<<');
    // return axios_post('/api/bytesungame/game-infos-list-n', data);
    return axios_post('/api/soofun/game-infos-list-n', data);
};
